
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../config');

class ModalPassword extends Component{
	constructor(props) {
		super(props);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.changePass = this.changePass.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.state = {
		    show: false,
		    old_pwd:"",
		    new_pwd:"",
		    c_pwd:"",
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleClose() {
		this.setState({ show: false, old_pwd:"", new_pwd:"", c_pwd:""});
	}

	handleShow() {
		this.setState({ show: true});
	}

	handleChange(e){
	    this.setState({
	      [e.target.name]: e.target.value
	    });
	}

	isValidForm() {
	    const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	changePass(){
		if(this.state.new_pwd.localeCompare(this.state.c_pwd) !== -1){
			document.getElementById('new_pwd').classList.remove('error');
			document.getElementById('c_pwd').classList.remove('error');
			
			var password = btoa(this.state.old_pwd);
			password = password.split("").reverse().join("");

			if(this.isValidForm()){
				this.props.waiting.handleShow('Cambiando...');
				fetch(Config.default.apiGateway.URL+'users/change_password?old_pwd='+password+
					'&new_pwd='+this.state.new_pwd,{
					method: 'POST',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						swal('Success', 'Contraseña Actualizada Correctamente', 'success');
						this.handleClose();
					}
				})
			}else{
				swal('Error', 'Campos Incompletos', 'error');
			}
		}else{
			document.getElementById('new_pwd').classList.add('error');
			document.getElementById('c_pwd').classList.add('error');
			swal('Error', 'Las Contraseñas deben coincidir', 'error');
		}
			
			
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_change_pwd.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{textAlign:"center"}}>
		        		<div className="col-xs-12 col-sm-10 col-md-offset-1">
		        			<div className="col-xs-12 form-group">
			        			<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			{t('content.modal_change_pwd.actual')}
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="old_pwd" id="old_pwd"
						        		type="password"
						        		value={this.state.old_pwd}
						        		onChange={this.handleChange}
						        		required/>
					        	</div>
				        	</div>

				        	<div className="form-group col-xs-12">
					        	<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			{t('content.modal_change_pwd.new')}
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="new_pwd" id="new_pwd"
						        		type="password"
						        		value={this.state.new_pwd}
						        		onChange={this.handleChange}
						        		required/>
					        	</div>
				        	</div>

				        	<div className="form-group col-xs-12">
					        	<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			{t('content.modal_change_pwd.confirm')}
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="c_pwd" id="c_pwd"
						        		type="password"
						        		value={this.state.c_pwd}
						        		onChange={this.handleChange}
						        		required/>
					        	</div>
				        	</div>
			        	</div>
			        	
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} onClick={this.changePass}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalPassword) 